

import React, { useState } from 'react';
import { Product, ProductType, User } from '../types';
import ProductCard from './ProductCard';
import { useTranslation } from '../hooks/useTranslation';

interface ProductsProps {
  products: Product[];
  onOpenAddToCartModal: (product: Product) => void;
  isB2BView: boolean;
  user: User | null;
}

const Products: React.FC<ProductsProps> = ({ products, onOpenAddToCartModal, isB2BView, user }) => {
  const [filter, setFilter] = useState<ProductType | 'all'>('all');
  const { t } = useTranslation();

  const filteredProducts = products.filter(p => filter === 'all' || p.type === filter);

  const FilterButton: React.FC<{ type: ProductType | 'all', label: string }> = ({ type, label }) => (
    <button
      onClick={() => setFilter(type)}
      className={`px-4 py-2 rounded-lg text-sm font-semibold transition-colors ${
        filter === type
          ? 'bg-brand-green text-white'
          : 'bg-transparent text-slate-600 hover:bg-brand-green/10 dark:text-slate-300 dark:hover:bg-slate-700'
      }`}
    >
      {label}
    </button>
  );

  return (
    <section id="products" className="py-24 bg-white dark:bg-slate-800/50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold font-serif text-brand-dark dark:text-white">{isB2BView ? t('b2b_products_title') : t('products_title')}</h2>
          <p className="mt-4 max-w-2xl mx-auto text-lg text-slate-600 dark:text-slate-300">
            {isB2BView ? t('b2b_products_subtitle') : t('products_subtitle')}
          </p>
        </div>

        <div className="flex justify-center items-center space-x-2 mb-12 p-1 border border-slate-200 dark:border-slate-700 rounded-lg">
            <FilterButton type="all" label={t('filter_all')} />
            <FilterButton type={"ToiletPaper"} label={t('filter_tp')} />
            <FilterButton type={"KitchenTowel"} label={t('filter_kt')} />
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-[repeat(auto-fit,minmax(280px,1fr))] gap-8">
          {filteredProducts.map(product => (
            <ProductCard key={product.id} product={product} onOpenAddToCartModal={onOpenAddToCartModal} isB2BView={isB2BView} user={user} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Products;